import { Button, HStack, VStack, Text, Image } from '@chakra-ui/react';
import {
  createHiddenDocument,
  removeHiddenDocument,
} from './virtual_theme_core';
import { extractScripts } from './extract_script_core';
import {
  theme1hor,
  theme1ver,
  theme2hor,
  theme2ver,
  theme3hor,
  theme3ver,
  theme4hor,
  theme4ver,
  theme5hor,
  theme5ver,
  theme6hor,
  theme6ver,
  theme7hor,
  theme7ver,
  theme8hor,
  theme8ver,
  theme9hor,
  theme9ver,
  theme10hor,
  theme10ver,
  theme11hor,
  theme11ver,
  theme12hor,
  theme12ver,
  theme13hor,
  theme13ver,
  theme14hor,
  theme14ver,
  theme15hor,
  theme15ver,
  theme16hor,
  theme16ver,
  theme17hor,
  theme17ver,
  theme18hor,
  theme18ver,
  theme19ver,
  theme19hor,
  theme20ver,
  theme20hor,
  theme21ver,
  theme21hor,
} from './../../pages/themes.js';
import { useEffect } from 'react';
import theme_3 from './../../assets/images/theme3.png';
import DraggableComponent from './draggable_widget';
const ThemeLoad = ({
  parentRef,
  setTheme,
  widgetsRef,
  orient = 'vertical',
  width,
  height,
  fabric_number,
  mainBlockRef,
}) => {
  const getBack = cssString => {
    const colorRegex = /background-color\s*:\s*([^;]*)\s*;?/i;
    const imageRegex = /background-image\s*:\s*([^;]*)\s*;?/i;

    const backgroundColorMatch = cssString.match(colorRegex);
    const backgroundImageMatch = cssString.match(imageRegex);

    const backgroundColor = backgroundColorMatch
      ? backgroundColorMatch[1].trim()
      : null;
    const backgroundImage = backgroundImageMatch
      ? backgroundImageMatch[1].trim()
      : null;

    return { color: backgroundColor, image: backgroundImage };
  };

  const getUserTheme = async () => {
    const response = await fetch(
      `https://admin.i-panel.pro:8787/api/panels/theme_id/${fabric_number}`,
      {
        method: 'GET',
        headers: {
          accept: 'application/json',
        },
      }
    );
    const result = await response.json();
    let data = result;
    setTheme(null);
    const hiddenTheme = createHiddenDocument(data[0]);
    const widgetsTheme3 = hiddenTheme.getElementsByClassName('design-3');
    const widgetsTheme1 = hiddenTheme.getElementsByClassName('design-1');
    const widgetsTheme2 = hiddenTheme.getElementsByClassName('design-2');
    const widgetsTheme4 = hiddenTheme.getElementsByClassName('design-4');
    const widgetsTheme5 = hiddenTheme.getElementsByClassName('design-5');
    const widgetsTheme6 = hiddenTheme.getElementsByClassName('design-6');
    const widgetsTheme7 = hiddenTheme.getElementsByClassName('design-7');
    let workspace = document.getElementById('workspace');

    if (hiddenTheme.querySelector('body > style')) {
      const back = getBack(
        hiddenTheme.querySelector('body > style')?.innerHTML
      );
      console.log(hiddenTheme.querySelector('body > style')?.innerHTML);
      console.log(back);
      console.log(workspace);

      if (workspace.style.backgroundColor != 'null') {
        workspace.style.backgroundColor = back.color;
      }
      if (workspace.style.backgroundImage != 'null') {
        workspace.style.backgroundImage = back.image;
      }
    }

    removeHiddenDocument(hiddenTheme);
    console.log(widgetsTheme3);
    let buffer = [];
    for (let elem of widgetsTheme3) {
      console.log(elem.outerHTML);
      buffer.push(
        <DraggableComponent
          parentRef={parentRef}
          html={elem.outerHTML}
          widgetsRef={widgetsRef}
          script={extractScripts(elem)}
          fromTheme={true}
          key={Math.random()}
        />
      );
    }
    for (let elem of widgetsTheme1) {
      console.log(elem.outerHTML);
      buffer.push(
        <DraggableComponent
          parentRef={parentRef}
          html={elem.outerHTML}
          widgetsRef={widgetsRef}
          script={extractScripts(elem)}
          fromTheme={true}
          key={Math.random()}
        />
      );
    }
    for (let elem of widgetsTheme2) {
      buffer.push(
        <DraggableComponent
          parentRef={parentRef}
          html={elem.outerHTML}
          widgetsRef={widgetsRef}
          script={extractScripts(elem)}
          fromTheme={true}
          key={Math.random()}
        />
      );
    }
    for (let elem of widgetsTheme4) {
      buffer.push(
        <DraggableComponent
          parentRef={parentRef}
          html={elem.outerHTML}
          widgetsRef={widgetsRef}
          script={extractScripts(elem)}
          fromTheme={true}
          key={Math.random()}
        />
      );
    }
    for (let elem of widgetsTheme5) {
      buffer.push(
        <DraggableComponent
          parentRef={parentRef}
          html={elem.outerHTML}
          widgetsRef={widgetsRef}
          script={extractScripts(elem)}
          fromTheme={true}
          key={Math.random()}
        />
      );
    }
    for (let elem of widgetsTheme6) {
      buffer.push(
        <DraggableComponent
          parentRef={parentRef}
          html={elem.outerHTML}
          widgetsRef={widgetsRef}
          script={extractScripts(elem)}
          fromTheme={true}
          key={Math.random()}
        />
      );
    }
    for (let elem of widgetsTheme7) {
      buffer.push(
        <DraggableComponent
          parentRef={parentRef}
          html={elem.outerHTML}
          widgetsRef={widgetsRef}
          script={extractScripts(elem)}
          fromTheme={true}
          key={Math.random()}
        />
      );
    }
    setTheme(buffer);
  };
  useEffect(() => {
    getUserTheme();
  }, []);

  return (
    <VStack>
      <HStack alignSelf={'flex-start'}>
        <Text
          alignSelf={'flex-start'}
          onClick={() => console.log(width, height)}
        >
          Выбор тем
        </Text>
        <Button onClick={() => setTheme(null)}>Очистить</Button>
        <Button
          onClick={() => {
            let grids = document.getElementsByClassName('react-draggable');
            let buffer = '';
            for (let elem of grids) {
              console.log(elem);

              if (elem.classList.contains('react-draggable')) {
                let elementRect = '';
                try {
                  elementRect = elem.getBoundingClientRect();
                } catch {
                  console.log(elem);
                }
                let parentRect = mainBlockRef.current.getBoundingClientRect();
                const isWithinParent =
                  elementRect.top >= parentRect.top &&
                  elementRect.left >= parentRect.left &&
                  elementRect.bottom <= parentRect.bottom &&
                  elementRect.right <= parentRect.right;
                if (isWithinParent) {
                  let position = {
                    x: elementRect.left - parentRect.left,
                    y: elementRect.top - parentRect.top,
                  };
                  const styles = window.getComputedStyle(elem.parentElement);
                  const backgroundWidgets = styles.getPropertyValue(
                    '--background-widgets'
                  );
                  const textColor = styles.getPropertyValue('--text-color');
                  console.log(backgroundWidgets, textColor);
                  buffer += `<div class="${
                    elem.classList
                  }" style="position: absolute !important; top: ${Math.round(
                    position.y
                  )}px !important; left: ${Math.round(
                    position.x
                  )}px !important; --background-widgets: ${backgroundWidgets} !important; --text-color: ${textColor} !important;">${
                    elem.innerHTML
                  }</div>`;
                }
              }
            }
            console.log(buffer);

            // Установите HTML как результат
            alert(
              `<div class="container" style="width:${width}px; height:${height}px;">${buffer}</div> <style>.container{
             background-image:${
               document.getElementById('workspace').style.backgroundImage
                 ? document.getElementById('workspace').style.backgroundImage
                 : 'none'
             }; background-color:${
                document.getElementById('workspace').style.backgroundColor
                  ? document.getElementById('workspace').style.backgroundColor
                  : 'none'
              };
            }</style>`
            );
          }}
        >
          Получить код темы(*для резервного копирования)
        </Button>
      </HStack>
      <HStack
        width={'65vw'}
        spacing={'60px'}
        overflowX={'scroll'}
        justify={'flex-start'}
      >
        {(width == 540 || width == 1080) &&
        (height == 1920 || height == 2560) ? (
          <>
            {' '}
            <VStack width={'100%'} align={'flex-start'}>
              <Text alignSelf={'flex-start'}>540x1920</Text>
              <HStack spacing={'20px'} width={'max-content'}>
                <Image
                  src={'http://212.41.9.251:8000/static/theme1ver540x1920.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme1ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-3');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}

                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme2ver540x1920.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme2ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-1');
                    let workspace = document.getElementById('workspace');

                    const back = getBack(
                      hiddenTheme.querySelector('body > style').innerHTML
                    );

                    workspace.style.backgroundColor = back.color;
                    workspace.style.backgroundImage = back.image;
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme3ver540x1920.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme3ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-4');
                    let workspace = document.getElementById('workspace');

                    const back = getBack(
                      hiddenTheme.querySelector('body > style').innerHTML
                    );
                    console.log(back);

                    workspace.style.backgroundColor = back.color;
                    workspace.style.backgroundImage = back.image;
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme4ver540x1920.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme4ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-1');
                    let workspace = document.getElementById('workspace');

                    const back = getBack(
                      hiddenTheme.querySelector('body > style').innerHTML
                    );

                    workspace.style.backgroundColor = back.color;
                    workspace.style.backgroundImage = back.image;
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme5ver540x1920.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme5ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-5');
                    let workspace = document.getElementById('workspace');

                    const back = getBack(
                      hiddenTheme.querySelector('body > style').innerHTML
                    );

                    workspace.style.backgroundColor = back.color;
                    workspace.style.backgroundImage = back.image;
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme6ver540x1920.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme6ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-2');
                    let workspace = document.getElementById('workspace');

                    const back = getBack(
                      hiddenTheme.querySelector('body > style').innerHTML
                    );

                    workspace.style.backgroundColor = back.color;
                    workspace.style.backgroundImage = back.image;
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
              </HStack>
            </VStack>
            <VStack width={'100%'} align={'flex-start'}>
              <Text alignSelf={'flex-start'}>1080x2560</Text>
              <HStack spacing={'20px'} width={'max-content'}>
                <Image
                  src={'http://212.41.9.251:8000/static/theme7ver540x1280.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme7ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-2');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}

                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme10ver540x1280.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme10ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-3');
                    let workspace = document.getElementById('workspace');

                    const back = getBack(
                      hiddenTheme.querySelector('body > style').innerHTML
                    );

                    workspace.style.backgroundColor = back.color;
                    workspace.style.backgroundImage = back.image;
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme11ver540x1280.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme11ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-5');
                    let workspace = document.getElementById('workspace');

                    const back = getBack(
                      hiddenTheme.querySelector('body > style').innerHTML
                    );
                    console.log(back);

                    workspace.style.backgroundColor = back.color;
                    workspace.style.backgroundImage = back.image;
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme12ver540x1280.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme12ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-4');
                    let workspace = document.getElementById('workspace');

                    const back = getBack(
                      hiddenTheme.querySelector('body > style').innerHTML
                    );

                    workspace.style.backgroundColor = back.color;
                    workspace.style.backgroundImage = back.image;
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme13ver540x1280.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme13ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-1');
                    let workspace = document.getElementById('workspace');

                    const back = getBack(
                      hiddenTheme.querySelector('body > style').innerHTML
                    );

                    workspace.style.backgroundColor = back.color;
                    workspace.style.backgroundImage = back.image;
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
              </HStack>
            </VStack>
            <VStack width={'100%'} align={'flex-start'}>
              <Text alignSelf={'flex-start'}>1080x1920</Text>
              <HStack spacing={'20px'} width={'max-content'}>
                <Image
                  src={'http://212.41.9.251:8000/static/theme8ver804x1430.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme8ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-2');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}

                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme14ver802x1426.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme14ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-3');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}

                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme15ver802x1426.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme15ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-5');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}

                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme16ver802x1426.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme16ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-4');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}

                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme17ver802x1426.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme17ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-1');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}

                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme18ver802x1914.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme18ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-3');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}

                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme19ver802x1914.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme19ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-5');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}

                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme20ver802x1914.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme20ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-4');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}

                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme21ver802x1914.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme21ver);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-1');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}

                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
              </HStack>
            </VStack>
          </>
        ) : (
          <>
            <VStack>
              <Text alignSelf={'flex-start'}>1920x540</Text>
              <HStack spacing={'20px'} width={'max-content'}>
                <Image
                  src={'http://212.41.9.251:8000/static/theme1hor1920x540.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme1hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-3');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}

                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme2hor1920x540.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme2hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-1');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme3hor1920x540.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme3hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-4');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme4hor1920x540.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme4hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-1');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme5hor1920x540.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme5hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-5');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme6hor1920x540.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme6hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-2');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={theme_3}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme7hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-2');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
              </HStack>
            </VStack>
            <VStack>
              <Text alignSelf={'flex-start'}>2560x1080</Text>
              <HStack spacing={'20px'} width={'max-content'}>
                <Image
                  src={'http://212.41.9.251:8000/static/theme7hor1280x540.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme7hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-2');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme10hor1280x540.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme10hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-3');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme11hor1280x540.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme11hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-5');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme12hor1280x540.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme12hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-4');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme13hor1280x540.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme13hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-1');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme14hor1426x802.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme14hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-3');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme15hor1426x802.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme15hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-5');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme16hor1426x802.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme16hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-4');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme17hor1426x802.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme17hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-1');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme18hor1914x802.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme18hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-3');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme20hor1914x802.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme20hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-4');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
                <Image
                  src={'http://212.41.9.251:8000/static/theme21hor1914x802.png'}
                  onClick={() => {
                    setTheme(null);
                    const hiddenTheme = createHiddenDocument(theme21hor);
                    const widgetsTheme =
                      hiddenTheme.getElementsByClassName('design-1');
                    let workspace = document.getElementById('workspace');
                    try {
                      const back = getBack(
                        hiddenTheme.querySelector('body > style').innerHTML
                      );

                      workspace.style.backgroundColor = back.color;
                      workspace.style.backgroundImage = back.image;
                    } catch {}
                    removeHiddenDocument(hiddenTheme);
                    console.log(widgetsTheme);
                    let buffer = [];
                    for (let elem of widgetsTheme) {
                      buffer.push(
                        <DraggableComponent
                          parentRef={parentRef}
                          html={elem.outerHTML}
                          widgetsRef={widgetsRef}
                          script={extractScripts(elem)}
                          fromTheme={true}
                          key={Math.random()}
                        />
                      );
                    }
                    setTheme(buffer);
                  }}
                  width={width * 0.2}
                  height={height * 0.2}
                  objectFit={'cover'}
                />
              </HStack>
            </VStack>
          </>
        )}

        {/* <Image
          src={theme_2}
          onClick={() => {
            setTheme(null)
            const hiddenTheme = createHiddenDocument(theme2);
            const widgetsTheme = hiddenTheme.getElementsByClassName('design-1');
            removeHiddenDocument(hiddenTheme)
            console.log(widgetsTheme);
            let buffer = [];
            for (let elem of widgetsTheme) {
              buffer.push(
                <DraggableComponent
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                />
              );
            }
            setTheme(buffer);
          
          }}
          width={540 * 0.2}
          height={1920 * 0.2}
          objectFit={'cover'}
        />{' '}
        <Image
          src={theme_3}
          onClick={() => {
            setTheme(null)
            const hiddenTheme = createHiddenDocument(theme3);
            const widgetsTheme = hiddenTheme.getElementsByClassName('design-4');
            removeHiddenDocument(hiddenTheme)
            console.log(widgetsTheme);
            let buffer = [];
            for (let elem of widgetsTheme) {
              buffer.push(
                <DraggableComponent
                  parentRef={parentRef}
                  html={elem.outerHTML}
                  widgetsRef={widgetsRef}
                  script={extractScripts(elem)}
                />
              );
            }
            setTheme(buffer);
          
          }}
          width={540 * 0.2}
          height={1920 * 0.2}
          objectFit={'cover'}
        />{' '} */}
      </HStack>
    </VStack>
  );
};

export default ThemeLoad;
